import { atomWithReset } from 'jotai/utils';
export const accessKeyIdAtom = atomWithReset<string>('');
export const secretAccessKeyAtom = atomWithReset<string>('');